import { IconComponent } from './types';

const FilledCircleIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={7}
    viewBox="0 0 7 7"
    fill="none"
    {...props}
  >
    <circle cx={3.5} cy={3.5} r={3.5} fill="currentColor" />
  </svg>
);
export default FilledCircleIcon;
